import EmberRouter from '@ember/routing/router';

import config from 'receivable-invoices-js/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

/* eslint-disable array-callback-return */
Router.map(function () {
  this.route('react-fallback', { path: '/*path' });
});
